import { BUILD_ID_FALLBACK } from './constants';

function removeLastSlash(str = '') {
  return str.replace(/\/$/, '');
}

// App build ID
export const BuildID = process.env.NX_PUBLIC_BUILD_ID || BUILD_ID_FALLBACK;
// NN api url
if (!process.env.NX_PUBLIC_API_URL) {
  throw new Error('API URL is not specified');
}
const ApiUrl = process.env.NX_PUBLIC_API_URL;
// api version
const ApiAppVersion = process.env.NX_PUBLIC_API_VERSION || '3.0.0';
// base path to assets on S3
const AssetsBaseUrl = removeLastSlash(process.env.NX_PUBLIC_ASSETS_URL);
// base url to SSO
const AuthBaseUrl = removeLastSlash(process.env.NX_PUBLIC_AUTH_URL);
// general debug flag (used by i18next currently)
const IsDebug = !!process.env.NX_PUBLIC_DEBUG;
// base url to locales bucket on S3
const LocalesBaseUrl = removeLastSlash(process.env.NX_PUBLIC_LOCALES_URL);
// id of canvas element used to render unity
const UnityCanvasId = process.env.NX_PUBLIC_UNITY_ID || 'exercise';
// optional memory limitation for unity
const UnityMemoryLimit = process.env.NX_PUBLIC_TOTAL_MEMORY;
// url to the current unity build on S3
const UnityPath = removeLastSlash(process.env.NX_PUBLIC_UNITY_PATH);
// separate unity debug flag
const UnityDebug = !!process.env.NX_PUBLIC_UNITY_DEBUG || IsDebug;
// url to onboarding app
const OnboardingAppPath = removeLastSlash(process.env.NX_PUBLIC_OPXP_ONBOARDING_URL);
// url to subscribe app
const SubscribeAppPath = removeLastSlash(process.env.NX_PUBLIC_OPXP_SUBSCRIBE_URL);
// url to user app
const UserAppPath = removeLastSlash(process.env.NX_PUBLIC_OPXP_USER_URL);
// url to social app
const SocialAppPath = removeLastSlash(process.env.NX_PUBLIC_OPXP_SOCIAL_URL);
// url to neuronation blog
const BlogPath = removeLastSlash(process.env.NX_PUBLIC_BLOG_URL);
// url to checkout page
const CheckoutUrl = removeLastSlash(process.env.NX_PUBLIC_CHECKOUT_URL);
// base path
const BasePath = process.env.NX_PUBLIC_BASE_PATH || process.env.NX_PUBLIC_URL || '/';
// url to FB group
const FBGroupUrl = process.env.NX_PUBLIC_FB_GROUP_URL;
// Vapid
const VapId = process.env.NX_PUBLIC_FIREBASE_VAPID_TOKEN || '';
// remoteConfig
const RemoteConfigBalancing = process.env.NX_PUBLIC_REMOTE_CONFIG_BALANCING || 'dynamic_balancing_workout_config';
const RemoteConfigCarousel = process.env.NX_PUBLIC_REMOTE_CONFIG_CAROUSEL || 'pre_workout_carousel_ms';
const RemoteConfigDomainCalculation =
  process.env.NX_PUBLIC_REMOTE_CONFIG_DOMAIN_CALCULATION || 'domain_calculation_config_dev';
const RemoteConfigTraining = process.env.NX_PUBLIC_REMOTE_CONFIG_TRAINING || 'training_config_dev';
const RemoteConfigWorkoutPopularity =
  process.env.NX_PUBLIC_REMOTE_CONFIG_WORKOUT_POPULARITY || 'workout_popularity_config_dev';

const RemoteConfigRevenueModel = process.env.NX_PUBLIC_REMOTE_CONFIG_REVENUE_MODEL || 'revenue_model_config_dev';
const RemoteConfigWelcomeMessage = process.env.NX_PUBLIC_REMOTE_CONFIG_WELCOME_MESSAGE || 'welcome_message_dev';
const RestoreSubscriptionRemoteConfig =
  process.env.NX_PUBLIC_REMOTE_CONFIG_RESTORE_PRODUCTS || 'restore_subscription_products_dev';
const WebRatingRequestConfig =
  process.env.NX_PUBLIC_REMOTE_CONFIG_WEB_RATING_REQUEST_CONFIG || 'web_rating_request_config_dev';
const RemoteConfigMacOsWarning = process.env.NX_PUBLIC_REMOTE_CONFIG_MACOS_WARNING || 'web_macos_warning';
const RemoteConfigExtras = process.env.NX_PUBLIC_REMOTE_CONFIG_EXTRAS || 'extras_config_dev';
const RemoteConfigExtraModes = process.env.NX_PUBLIC_REMOTE_CONFIG_EXTRA_MODES || 'extra_modes_dev';
const RemoteConfigUnity = process.env.NX_PUBLIC_REMOTE_CONFIG_UNITY || 'unity_dev';
const RemoteConfigBlogPreview = process.env.NX_PUBLIC_REMOTE_CONFIG_BLOG_PREVIEW || 'blog_preview_dev';
const RemoteConfigDay0Banner = process.env.NX_PUBLIC_REMOTE_CONFIG_DAY0_BANNER || 'day0_banner_dev';
const RemoteConfigChallenge = process.env.NX_PUBLIC_REMOTE_CONFIG_CHALLENGE || 'challenge_dev';
const RemoteConfigWelcomeLp = process.env.NX_PUBLIC_REMOTE_CONFIG_WELCOME_LP || 'welcome_lp_dev';

const PrivacyPolicyUrl = `${AuthBaseUrl}/legals/dataprivacy/?theme=opxp`;

// Firebase config object
let FirebaseConfig;
if (process.env.NODE_ENV === 'test') {
  FirebaseConfig = {
    apiKey: 'mock-api-key',
    authDomain: 'mock-auth-domain',
    databaseURL: 'mock-database-url',
    projectId: 'mock-project-id',
    storageBucket: 'mock-storage-bucket',
    messagingSenderId: 'mock-messaging-sender-id',
    appId: 'mock-app-id',
    measurementId: 'mock-measurement-id',
  };
} else {
  FirebaseConfig = {
    apiKey: process.env.NX_PUBLIC_FIREBASE_API_KEY || '',
    authDomain: process.env.NX_PUBLIC_FIREBASE_DOMAIN,
    databaseURL: process.env.NX_PUBLIC_FIREBASE_URL,
    projectId: process.env.NX_PUBLIC_FIREBASE_PROJECT_ID || '',
    storageBucket: process.env.NX_PUBLIC_FIREBASE_BUCKET,
    messagingSenderId: process.env.NX_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: process.env.NX_PUBLIC_FIREBASE_APP_ID || '',
    measurementId: process.env.NX_PUBLIC_FIREBASE_MEASUREMENT_ID || '',
  };
}

const ENV = {
  ApiUrl,
  ApiAppVersion,
  AssetsBaseUrl,
  AuthBaseUrl,
  IsDebug,
  LocalesBaseUrl,
  UnityCanvasId,
  UnityMemoryLimit,
  UnityPath,
  OnboardingAppPath,
  UnityDebug,
  SubscribeAppPath,
  UserAppPath,
  SocialAppPath,
  BlogPath,
  CheckoutUrl,
  BasePath,
  VapId,
  RemoteConfigBalancing,
  RemoteConfigCarousel,
  RemoteConfigDomainCalculation,
  RemoteConfigTraining,
  RemoteConfigWorkoutPopularity,
  RemoteConfigRevenueModel,
  RemoteConfigWelcomeMessage,
  RestoreSubscriptionRemoteConfig,
  RemoteConfigMacOsWarning,
  RemoteConfigExtras,
  RemoteConfigExtraModes,
  RemoteConfigUnity,
  RemoteConfigBlogPreview,
  RemoteConfigDay0Banner,
  RemoteConfigChallenge,
  RemoteConfigWelcomeLp,
  PrivacyPolicyUrl,
  FBGroupUrl,
  WebRatingRequestConfig,
  FirebaseConfig,
};

export default ENV;
